import { render } from "./EditRealEstateAreas.vue?vue&type=template&id=65859b47"
import script from "./EditRealEstateAreas.vue?vue&type=script&lang=js"
export * from "./EditRealEstateAreas.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__